const ttModulesList = {
  /** Parent module for AI features (must match `Modules.Name` on the API). */
  AI: "AI",
  Administration: "Administration",
  AdvDash: {
    Root: "Advanced Dashboard",
  },
  CoffeeChats: "Coffee Chats",
  CompanyDash: "Company Dashboard",
  Dashboard: {
    Root: "Dashboard",
  },
  Journeys: "Journeys",
  MobileApp: "Mobile App",
  Profiles: "Profiles",
  Reports: "Reports",
  Reviews: "Reviews",
  SSO: "SingleSignOn",
  Tasks: {
    Root: "Tasks",
  },
  TempChecks: "Temperature Checks",
  Ai: {
    SpeechToText: "AI Speech to Text",
  },
  SelfServeNotifications: "Self Serve Notifications",
};

export default ttModulesList;
